<script setup lang="ts">
import { useI18n } from "vue-i18n";
// 切换语言
const { locale, t } = useI18n();
import { onMounted } from "vue";
import { detectUserRegion } from "./utils/ipService";
onMounted(async () => {
  // 如果用户没有手动设置过语言
  if (!localStorage.getItem("locale")) {
    try {
      const countryCode = await detectUserRegion();
      // 根据国家代码设置语言
      const defaultLocale = ["CN", "HK", "TW", "MO"].includes(countryCode)
        ? "zh-cn"
        : "en";
      localStorage.setItem("locale", defaultLocale);
      locale.value = defaultLocale;
    } catch (error) {
      // 如果检测失败，默认使用中文
      localStorage.setItem("locale", "zh-cn");
      locale.value = "zh-cn";
    }
  }
});
</script>

<template>
  <div class="root">
    <RouterView></RouterView>
  </div>
</template>
<style lang="scss" scoped></style>
